module.exports = __webpack_public_path__ + "img/rimg4.ba35fc68.png";